import { useEffect, useState } from 'react';
import { InspectionCategoryTypeModel, InspectionModel } from '../data/types';
import { InspectionCategory, InspectionCategoryType } from '../data/enums';
import { inspectionDB } from '../data/database.structure';
import { InspectionViewModel } from '../data/viewmodels.types';

const useInspectionCategoryType = ({
  categoryType,
  category,
  inspection,
  inspectionId,
}: {
  category?: InspectionCategory; //TODO: Deprecated, remove in the future
  categoryType?: InspectionCategoryType; //TODO: Deprecated, remove in the future
  inspection?: InspectionViewModel | null;
  inspectionId?: string;
}) => {
  const [inspectionCategoryType, setType] =
    useState<InspectionCategoryTypeModel | null>();

  useEffect(() => {
    async function searchCatetoryType(inspection: InspectionModel) {
      const inspectionCategoryType = inspection.inspectionCategoryTypes?.find(
        (c) =>
          c.category.toLowerCase() ===
            InspectionCategory.allCategories.toLowerCase() &&
          c.type.toLowerCase() ===
            InspectionCategoryType.allTypes.toLowerCase(),
      );

      setType(inspectionCategoryType);
    }

    async function getInspectionCategoryType(inspectionId: string) {
      const inspection = await inspectionDB.inspections.get(inspectionId);

      if (inspection) {
        searchCatetoryType(inspection);
      }
    }

    if (inspectionId) {
      getInspectionCategoryType(inspectionId);
    } else if (inspection && inspection.inspection) {
      searchCatetoryType(inspection.inspection);
    }
  }, [inspection, inspectionId]);

  return inspectionCategoryType;
};

export default useInspectionCategoryType;
